'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import { faHeart } from '@awesome.me/kit-94e593bf23/icons/classic/solid';
import { faHeart as faHeartLight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import Price from '@/app/_components/Price';
import Tooltip from '@/app/_components/Tooltip';
const SwatchLines = t0 => {
  const $ = _c(16);
  const {
    activeTab,
    swatchSet,
    currentSwatch,
    handleSwatchSelect,
    swatchFavorites: t1,
    onToggleFavorite
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const swatchFavorites = t2;
  if (!swatchSet.swatchLines) {
    return null;
  }
  const t3 = `w-full px-[var(--site-padding)] py-4 scrollbar bg-white ${activeTab == "swatches" ? "block" : "hidden"}`;
  let t4;
  if ($[2] !== currentSwatch?.swatch_id || $[3] !== handleSwatchSelect || $[4] !== onToggleFavorite || $[5] !== swatchFavorites || $[6] !== swatchSet.swatchLines) {
    let t5;
    if ($[8] !== currentSwatch?.swatch_id || $[9] !== handleSwatchSelect || $[10] !== onToggleFavorite || $[11] !== swatchFavorites) {
      t5 = swatchLine => <div key={swatchLine.swatch_line_id} className="z-10 mb-8 tooltip-container"><div className="pl-1 font-medium text-base capitalize">{swatchLine.swatch_line_name} <span className={`text-primary ${swatchLine.price > 0 ? "inline-block" : "hidden"}`}>+ <Price amount={swatchLine.price} /></span></div>{swatchLine.swatch_line_description && swatchLine.swatch_line_description.length > 0 && <p className="pl-1 text-base text-light mb-1 whitespace-pre-line">{swatchLine.swatch_line_description}</p>}<div className="grid grid-cols-[repeat(auto-fill,81px)] gap-1">{swatchLine.swatches && swatchLine.swatches.map(swatch => <div key={swatch.swatch_id} className="shrink-0 relative group"><button onClick={e => {
              e.stopPropagation();
              onToggleFavorite && onToggleFavorite(swatch);
            }} className={`absolute top-1 right-2 z-10 transition-opacity duration-150 ${swatchFavorites[swatch.swatch_id] ? "opacity-100" : "opacity-100 [@media(pointer:fine)]:opacity-0 [@media(pointer:fine)]:group-hover:opacity-100"}`} aria-label={swatchFavorites[swatch.swatch_id] ? "Remove from favorites" : "Add to favorites"}><FontAwesomeIcon icon={swatchFavorites[swatch.swatch_id] ? faHeart : faHeartLight} className={`text-sm ${swatchFavorites[swatch.swatch_id] ? "text-red" : "text-light hover:text-red"}`} style={{
                stroke: "white",
                strokeWidth: "30px",
                paintOrder: "stroke fill"
              }} /></button><Tooltip content={<>{swatch.swatch_name}{swatch.swatch_code && <span className="pl-0.5 text-light">({swatch.swatch_code})</span>}{swatchLine.price > 0 && <span className="text-primary pl-1">+ <Price amount={swatchLine.price} /></span>}{swatch.swatch_price > 0 && <span className="text-primary pl-1">+ <Price amount={swatch.swatch_price} /></span>}</>} side="bottom" mobileMode="disabled"><button onClick={() => handleSwatchSelect(swatch)} className="w-full"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/${swatch.swatch_photo}`} alt={swatch.swatch_name} width={75} height={75} className={`min-w-[75px] min-h-[75px] box-content border-1 p-0.5 ${currentSwatch?.swatch_id == swatch.swatch_id ? " border-primary" : "border-white"}`} /></button></Tooltip></div>)}</div></div>;
      $[8] = currentSwatch?.swatch_id;
      $[9] = handleSwatchSelect;
      $[10] = onToggleFavorite;
      $[11] = swatchFavorites;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = swatchSet.swatchLines.map(t5);
    $[2] = currentSwatch?.swatch_id;
    $[3] = handleSwatchSelect;
    $[4] = onToggleFavorite;
    $[5] = swatchFavorites;
    $[6] = swatchSet.swatchLines;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default SwatchLines;

// className="absolute z-40 -bottom-9 bg-gray-5 shadow shadow-black/[.3] p-2 opacity-0 mt-1 text-black text-nowrap text-xs text-left group-hover:block group-hover:opacity-100 transition-opacity duration-150">